import React, { Component, memo } from 'react'
import { compose, pure } from 'recompose'
import { connect } from 'react-redux'
import { shallowCompare } from 'helpers/Utils'
import _ from 'lodash'

import {
    productHierarchyValueSelector,
    productSourceSelector
} from '../selectors'
import Checkbox from './Checkbox'
import {
    updateSelectedProductFilter
} from '../actions'

const MemoCheckbox = memo(Checkbox)

const mapStateToProps = (state) => {
    return {
        productHierarchyValue: productHierarchyValueSelector(state),
        productSources: productSourceSelector(state),
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        update: (parent, value) => dispatch(updateSelectedProductFilter(parent, value))
    } 
}

class ListItem extends Component {
    shouldComponentUpdate(nextProps, state) {
        let parent = this.props.parent
        let funcA = this.props.productSources(parent)
        let funcB = nextProps.productSources(parent)
        return shallowCompare(funcA, funcB)
    }
    updateFilterFunc = (parent, ids) => {
        return () => this.props.update(parent, ids)
    }
    render() {
        const { parent, child, productHierarchyValue, productSources } = this.props
        const query = productHierarchyValue(parent)
        const items = productSources(parent)
        return (
            Object.keys(items)
                .map((value, idx) => {
                    return (
                        <MemoCheckbox
                            key={value}
                            value={value}
                            query={query}
                            items={items}
                            parent={parent}
                            updateFilterFunc={this.updateFilterFunc(parent, items[value])}
                        />
                    )
                })
        )
    }
}


const withConnect = connect(mapStateToProps, mapDispatchToProps)
const enhance = compose (
    withConnect
)
export default enhance(ListItem)